<template>
  <div class="navbar">
    <div style="width:100%;height:66px;box-shadow: rgb(0 21 41 / 9%) 0px 1px 4px;}">
      <hamburger
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar"
      />

      <breadcrumb class="breadcrumb-container" />

      <div class="right-menu">
        <el-dropdown class="avatar-container" trigger="click">
          <div class="avatar-wrapper">
            <img :src="avatarUrl" class="user-avatar" @error="handleAvatarError">
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown" class="user-dropdown">
            <router-link to="/myself">
              <el-dropdown-item> 个人中心 </el-dropdown-item>
            </router-link>
            <router-link to="/change-password">
              <el-dropdown-item> 修改密码</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided @click.native="logout">
              <span style="display: block">Log Out</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- tags -->
    <div
      style="
        width: 100%;
        height: 45px;
        background-color: write;
        overflow: hidden;
        display: flex;
        align-items: center;
      "
    >
      <template v-for="(item,index) in tags">
        <el-tag
          v-if="item.title"
          :key="index"
          closable
          disable-transitions
          style="border: 1px solid #cacaca"
          :class="{ active: item.checked }"
          @click="$router.push(item.path)"
          @close="$store.commit('menu/REMOVE_TAG', item)"
        >
          {{ item.title }}
        </el-tag>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { getToken } from '@/utils/auth'
import { parseJwt } from '@/utils/jwtUtils'
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      user: {},
      defaultAvatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFNUU3RUIiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDEyQzE0LjIwOTEgMTIgMTYgMTAuMjA5MSAxNiA4QzE2IDUuNzkwODYgMTQuMjA5MSA0IDEyIDRDOS43OTA4NiA0IDggNS43OTA4NiA4IDhDOCAxMC4yMDkxIDkuNzkwODYgMTIgMTIgMTJaIiBmaWxsPSIjOUM5QzlDIi8+CjxwYXRoIGQ9Ik0xMiAxNEM5LjMzIDE0IDcuMDEgMTUuMjQgNS4zNiAxNy4yNEM2LjY3IDE5LjI0IDkuMTkgMjAgMTIgMjBDMTQuODEgMjAgMTcuMzMgMTkuMjQgMTguNjQgMTcuMjRDMTYuOTkgMTUuMjQgMTQuNjcgMTQgMTIgMTRaIiBmaWxsPSIjOUM5QzlDIi8+Cjwvc3ZnPgo8L3N2Zz4K'
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'tags']),
    avatarUrl() {
      console.log('Navbar avatarUrl - this.avatar:', this.avatar)
      const { getUserAvatarUrl } = require('@/utils/minio')
      const processedUrl = getUserAvatarUrl(this.avatar)
      return processedUrl || this.defaultAvatar
    }
  },
  created() {
    this.decode()
    // 获取用户信息，包括头像
    // 在 AMC 等级选择页跳过 /user/info 请求，避免进入本页时再次请求用户信息
    if (this.$route && this.$route.path === '/amc-level-select') {
      return
    }
    this.getUserInfo()
  },
  methods: {
    decode() {
      const token = getToken()
      const user = parseJwt(token)
      this.user = JSON.parse(user.userInfo)
    },
    async getUserInfo() {
      try {
        console.log('Navbar getUserInfo - 开始获取用户信息')
        // 调用store的getInfo action获取用户信息，包括头像
        const result = await this.$store.dispatch('user/getInfo')
        console.log('Navbar getUserInfo - 获取用户信息成功:', result)
        console.log('Navbar getUserInfo - store中的avatar:', this.$store.state.user.avatar)
      } catch (error) {
        console.error('Navbar getUserInfo - 获取用户信息失败:', error)
      }
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      this.$store.dispatch('logoutUser')
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    },
    handleAvatarError(event) {
      // 头像加载失败时，使用默认头像
      event.target.src = this.defaultAvatar
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tag {
  background-color: #ffffff;
  border-color: #cacaca;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  margin-left: 5px;
  font-size: 12px;
  color: #000000;
  border-width: 1.5px;
  border-style: solid;
  border-radius: 3px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}

.active {
  background-color: #58b289;
  color: rgb(255, 255, 255);
}

.navbar {
  height: 110px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgb(0 21 41 / 16%);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
